import { styled, Box, css } from '@mui/material'
import { MinAmountStylesProps, IndicatorProps } from './MinAmount.types'
import Text from '../Text'
import Price from '../Price'

export const MinAmountWrapper = styled(Box)(
  () =>
    css`
      display: flex;
      flex-direction: column;
      padding: 12px 16px;

      &:first-of-type {
        padding-top: 16px;
      }
    `
)

export const Message = styled(Text)(
  () =>
    css`
      margin-bottom: 12px;
    `
)
Message.defaultProps = {
  align: 'center'
}

export const MinAmountValue = styled(Price)(() => css``)
MinAmountValue.defaultProps = {
  size: 'inherit'
}

export const Indicator = styled(Box)<MinAmountStylesProps & IndicatorProps>(
  ({ theme, value, color }) =>
    css`
      background: ${theme.palette.grey[300]};
      border-radius: 100px;
      height: 4px;
      position: relative;
      width: 100%;
      overflow: hidden;

      &:before {
        content: '';
        bottom: 0;
        position: absolute;
        left: 0;
        top: 0;
        background: ${color || theme.palette.primary.main};
        width: ${`${value}%`};
      }
    `
)
